import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';

import useGlobalState from 'actions';
import guidance from 'assets/guidance_photo.png';
import sim_guidance from 'assets/sim_guidance.png';
import kk_guidance from 'assets/kk_guidance.png';
import ektp_guidance from 'assets/ektp_guidance.png';
import passport_guidance from 'assets/guidance_photo.png';

interface PhotoUploadGuidanceProps {
  padding?: string | null;
  open: boolean;
  onClose: () => void;
}

const PhotoUploadGuidance = (props: PhotoUploadGuidanceProps) => {
  const [state] = useGlobalState();

  return (
    <Grid
      item
      xs={12}
      style={{
        padding: props.padding
          ? parseInt(props.padding) > 0
            ? props.padding
            : 16
          : 0,
        cursor: 'pointer',
      }}
    >
      <Drawer
        anchor='bottom'
        open={props.open}
        onClose={props.onClose}
        style={{ zIndex: 9999 }}
      >
        {state.img_type === 'sim_privy' ? (
          <div className='center-align-photo-div'>
            <div
              style={{
                marginLeft: 5,
                marginTop: 15,
                marginRight: 5,
                width: '96%',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              className='photoUploadHeader'
            >
              Petunjuk upload {state.img_caption}
            </div>
            <div
              style={{ width: '100%', paddingTop: '10px', cursor: 'pointer' }}
            >
              <Divider />
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
            >
              <img src={sim_guidance} alt='guidance' />
            </div>
            <div
              style={{
                marginTop: 15,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{ paddingLeft: '15px', paddingRight: '25px' }}
                className='photoUploadHeader'
              >
                Petunjuk upload {state.img_caption}
              </div>
            </div>
            <div
              style={{
                paddingTop: '15px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                1. Pastikan SIM yang diunggah jelas dan sesuai dengan identitas
                Anda.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                2. Jangan gunakan foto yang terpotong atau kurang jelas.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                paddingBottom: '10px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                3. Pastikan SIM yang Anda unggah masih berlaku
              </div>
            </div>
            <div
              style={{
                marginTop: 2,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '15px',
                  paddingRight: '25px',
                  paddingBottom: '15px',
                }}
                className='photoUploadLabel2'
              >
                Pastikan untuk pilih Allow, Izinkan atau Setuju pada pop up
                perizinan untuk melanjutkan proses aplikasi.
              </div>
            </div>
          </div>
        ) : state.img_type === 'passport_privy' ? (
          <div className='center-align-photo-div'>
            <div
              style={{
                marginLeft: 5,
                marginTop: 15,
                marginRight: 5,
                width: '96%',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              className='photoUploadHeader'
            >
              Petunjuk upload {state.img_caption}
            </div>
            <div
              style={{ width: '100%', paddingTop: '10px', cursor: 'pointer' }}
            >
              <Divider />
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
            >
              <img src={passport_guidance} alt='guidance' />
            </div>
            <div
              style={{
                marginTop: 15,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{ paddingLeft: '15px', paddingRight: '25px' }}
                className='photoUploadHeader'
              >
                Petunjuk upload {state.img_caption}
              </div>
            </div>
            <div
              style={{
                paddingTop: '15px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                1. Pastikan Paspor yang diunggah jelas dan sesuai dengan
                identitas Anda.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                2. Jangan gunakan foto yang terpotong atau kurang jelas.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                paddingBottom: '10px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                3. Pastikan Paspor yang kamu unggah masih berlaku.
              </div>
            </div>
            <div
              style={{
                marginTop: 2,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '15px',
                  paddingRight: '25px',
                  paddingBottom: '15px',
                }}
                className='photoUploadLabel2'
              >
                Pastikan untuk pilih Allow, Izinkan atau Setuju pada pop up
                perizinan untuk melanjutkan proses aplikasi.
              </div>
            </div>
          </div>
        ) : state.img_type === 'kk_privy' ? (
          <div className='center-align-photo-div'>
            <div
              style={{
                marginLeft: 5,
                marginTop: 15,
                marginRight: 5,
                width: '96%',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              className='photoUploadHeader'
            >
              Petunjuk upload {state.img_caption}
            </div>
            <div
              style={{ width: '100%', paddingTop: '10px', cursor: 'pointer' }}
            >
              <Divider />
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
            >
              <img src={kk_guidance} alt='guidance' />
            </div>
            <div
              style={{
                marginTop: 15,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{ paddingLeft: '15px', paddingRight: '25px' }}
                className='photoUploadHeader'
              >
                Petunjuk upload {state.img_caption}
              </div>
            </div>
            <div
              style={{
                paddingTop: '15px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                1. Pastikan KK yang diunggah jelas dan sesuai dengan identitas
                Anda.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                paddingBottom: '10px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                2. Jangan gunakan foto yang diunggah terpotong atau kurang
                jelas.
              </div>
            </div>
            <div
              style={{
                marginTop: 2,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '15px',
                  paddingRight: '25px',
                  paddingBottom: '15px',
                }}
                className='photoUploadLabel2'
              >
                Pastikan untuk pilih Allow, Izinkan atau Setuju pada pop up
                perizinan untuk melanjutkan proses aplikasi.
              </div>
            </div>
          </div>
        ) : state.img_type === 'ektp_privy' ? (
          <div className='center-align-photo-div'>
            <div
              style={{
                marginLeft: 5,
                marginTop: 15,
                marginRight: 5,
                width: '96%',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              className='photoUploadHeader'
            >
              Petunjuk upload {state.img_caption}
            </div>
            <div
              style={{ width: '100%', paddingTop: '10px', cursor: 'pointer' }}
            >
              <Divider />
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
            >
              <img src={ektp_guidance} alt='guidance' />
            </div>
            <div
              style={{
                marginTop: 15,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{ paddingLeft: '15px', paddingRight: '25px' }}
                className='photoUploadHeader'
              >
                Petunjuk upload {state.img_caption}
              </div>
            </div>
            <div
              style={{
                paddingTop: '15px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                1. Pastikan e-KTP yang diunggah jelas dan sesuai dengan
                identitas Anda.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                paddingBottom: '10px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                2. Jangan gunakan foto yang diunggah terpotong atau kurang
                jelas.
              </div>
            </div>
            <div
              style={{
                marginTop: 2,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '15px',
                  paddingRight: '25px',
                  paddingBottom: '15px',
                }}
                className='photoUploadLabel2'
              >
                Pastikan untuk pilih Allow, Izinkan atau Setuju pada pop up
                perizinan untuk melanjutkan proses aplikasi.
              </div>
            </div>
          </div>
        ) : (
          <div className='center-align-photo-div'>
            <div
              style={{
                marginLeft: 5,
                marginTop: 15,
                marginRight: 5,
                width: '96%',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              className='photoUploadHeader'
            >
              Petunjuk upload {state.img_caption}
            </div>
            <div
              style={{ width: '100%', paddingTop: '10px', cursor: 'pointer' }}
            >
              <Divider />
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
                paddingTop: '10px',
              }}
            >
              <img src={guidance} alt='guidance' />
            </div>
            <div
              style={{
                marginTop: 15,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{ paddingLeft: '15px', paddingRight: '25px' }}
                className='photoUploadHeader'
              >
                Petunjuk upload {state.img_caption}
              </div>
            </div>
            <div
              style={{
                paddingTop: '15px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                1. Pastikan KTP yang diunggah jelas dan sesuai dengan identitas
                kamu.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                2. Jangan sampai foto yang diunggah terpotong atau kurang jelas.
              </div>
            </div>
            <div
              style={{
                paddingTop: '8px',
                paddingBottom: '10px',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '35px',
                  paddingRight: '35px',
                  textAlign: 'left',
                }}
                className='photoUploadLabel2'
              >
                3. Pastikan KTP yang kamu unggah masih berlaku
              </div>
            </div>
            <div
              style={{
                marginTop: 2,
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  paddingLeft: '15px',
                  paddingRight: '25px',
                  paddingBottom: '15px',
                }}
                className='photoUploadLabel2'
              >
                Pastikan untuk pilih Allow, Izinkan atau Setuju pada pop up
                perizinan untuk melanjutkan proses aplikasi.
              </div>
            </div>
          </div>
        )}
      </Drawer>
    </Grid>
  );
};

export default PhotoUploadGuidance;
